import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BoschUiTableService } from '../bosch-ui-table.service';
import { BoschUiRowDefDirective } from '../directives/bosch-ui-row-def.directive';
import { map, takeWhile } from 'rxjs';

@Component({
  selector: 'bosch-ui-table-row',
  templateUrl: './bosch-ui-table-row.component.html',
  styleUrls: ['./bosch-ui-table-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BoschUiTableRowComponent<DataType> {
  public readonly tableService = inject(BoschUiTableService<DataType>);
  public readonly boschUiRowDefDirective = inject(BoschUiRowDefDirective<DataType>, { host: true });

  public rowIndex = this.boschUiRowDefDirective.getRowIndex();
  public rowDisplayColumns = this.boschUiRowDefDirective.rowDisplayColumns;
  public rowData$ = this.boschUiRowDefDirective.rowsData$.pipe(
    takeWhile((rowsData: DataType[]) => rowsData.length > this.rowIndex),
    map((rowsData: DataType[]) => {
      const row = rowsData[this.rowIndex];
      this.boschUiRowDefDirective.incrementRowIndex();

      return row;
    }),
  );

  trackByFn(index: number): string {
    return `cell_${index}`;
  }
}
